/*Graph*/
interface IconProps{
    width?:number;
    height?:number;
    fill?:string;
}
interface DelteCrossProps extends IconProps{
  onClick:()=>void;
}
const Gifts = ({width,height,fill}:IconProps) => {
  return(
     <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      fill={fill ?? "#344952"}
      id="SVGRepo_iconCarrier"
      d="M9 4v3.234L5.516 5.143 4.484 6.857 6.39 8H3v19h6v-2H5V10h8.027c.833-.62 1.857-1 2.973-1 .352 0 .682.042 1 .102V8h-3.389l1.905-1.143-1.032-1.714L11 7.234V4zm7 7c-1.645 0-3 1.355-3 3 0 .352.075.684.188 1H11v12h18V15h-2.187A2.9 2.9 0 0 0 27 14c0-1.645-1.355-3-3-3-1.75 0-2.938 1.328-3.719 2.438-.105.147-.188.294-.281.439-.094-.145-.176-.29-.281-.44C18.937 12.328 17.75 11 16 11m0 2c.625 0 1.438.672 2.063 1.563.152.218.129.231.25.439H16c-.566 0-1-.434-1-1A.985.985 0 0 1 16 13m8 0c.566 0 1 .434 1 1s-.434 1-1 1h-2.312c.122-.207.098-.22.25-.437C22.563 13.67 23.375 13 24 13m-11 4h6v8h-6zm8 0h6v8h-6z"
    ></path>
  </svg>
  );
}
const Graph = ({width,height,fill}:IconProps) =>{
    return(
         <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <g id="SVGRepo_iconCarrier">
      <defs>
        <clipPath id="clip-barchart">
          <path d="M0 0h32v32H0z"></path>
        </clipPath>
      </defs>
      <g id="barchart" clipPath="url(#clip-barchart)">
        <g id="Group_1837" data-name="Group 1837" transform="translate(0 -468)">
          <g id="Group_1827" data-name="Group 1827">
            <g id="Group_1820" data-name="Group 1820">
              <g id="Group_1819" data-name="Group 1819">
                <g id="Group_1818" data-name="Group 1818">
                  <path
                    id="Path_3746"
                    fill={fill ?? "#344952"}
                    d="M30.667 497.106H3.894a1 1 0 0 1-1-1v-26.773a1 1 0 0 1 2 0v25.773h25.773a1 1 0 0 1 0 2"
                    data-name="Path 3746"
                  ></path>
                </g>
              </g>
            </g>
            <g id="Group_1823" data-name="Group 1823">
              <g id="Group_1822" data-name="Group 1822">
                <g id="Group_1821" data-name="Group 1821">
                  <path
                    id="Path_3747"
                    fill={fill ?? "#344952"}
                    d="M6.454 473.6a1 1 0 0 1-.787-.383l-1.773-2.262-1.773 2.262a1 1 0 0 1-1.575-1.235l2.56-3.265a1.037 1.037 0 0 1 1.575 0l2.56 3.265a1 1 0 0 1-.787 1.618"
                    data-name="Path 3747"
                  ></path>
                </g>
              </g>
            </g>
            <g id="Group_1826" data-name="Group 1826">
              <g id="Group_1825" data-name="Group 1825">
                <g id="Group_1824" data-name="Group 1824">
                  <path
                    id="Path_3748"
                    fill={fill ?? "#344952"}
                    d="M27.4 499.667a1 1 0 0 1-.617-1.787l2.262-1.774-2.262-1.773a1 1 0 1 1 1.234-1.574l3.266 2.56a1 1 0 0 1 0 1.575l-3.266 2.56a1 1 0 0 1-.617.213"
                    data-name="Path 3748"
                  ></path>
                </g>
              </g>
            </g>
          </g>
          <g id="Group_1830" data-name="Group 1830">
            <g id="Group_1829" data-name="Group 1829">
              <g id="Group_1828" data-name="Group 1828">
                <path
                  id="Path_3749"
                  fill={fill ?? "#344952"}
                  d="M10.563 493.962H7.2a1 1 0 0 1-1-1V480.5a1 1 0 0 1 1-1h3.359a1 1 0 0 1 1 1v12.462a1 1 0 0 1-.996 1m-2.359-2h1.359V481.5H8.2Z"
                  data-name="Path 3749"
                ></path>
              </g>
            </g>
          </g>
          <g id="Group_1833" data-name="Group 1833">
            <g id="Group_1832" data-name="Group 1832">
              <g id="Group_1831" data-name="Group 1831">
                <path
                  id="Path_3750"
                  fill={fill ?? "#344952"}
                  d="M17.406 493.962h-3.359a1 1 0 0 1-1-1v-15.8a1 1 0 0 1 1-1h3.359a1 1 0 0 1 1 1v15.8a1 1 0 0 1-1 1m-2.359-2h1.359v-13.8h-1.359Z"
                  data-name="Path 3750"
                ></path>
              </g>
            </g>
          </g>
          <g id="Group_1836" data-name="Group 1836">
            <g id="Group_1835" data-name="Group 1835">
              <g id="Group_1834" data-name="Group 1834">
                <path
                  id="Path_3751"
                  fill={fill ?? "#344952"}
                  d="M24.25 493.962h-3.359a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h3.359a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1m-2.359-2h1.359v-8h-1.359Z"
                  data-name="Path 3751"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
    )
}
/*Group*/

const UserGroup = ({width,height,fill}:IconProps) => {
    return(
        <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      fill={fill ?? "#000"}
      d="M15.8 21a.7.7 0 1 0 1.4 0zm-11 0a.7.7 0 1 0 1.4 0zm1.4-3a.7.7 0 1 0-1.4 0zm6.1 3a.7.7 0 1 0 1.4 0zm1.4-3a.7.7 0 1 0-1.4 0zm-1.957-6.687-.393-.58zm4.5 0-.393-.58zM3.2 21v-1.5H1.8V21zM8 14.7h3v-1.4H8zm7.8 4.8V21h1.4v-1.5zM11 14.7a4.8 4.8 0 0 1 4.8 4.8h1.4a6.2 6.2 0 0 0-6.2-6.2zm-7.8 4.8A4.8 4.8 0 0 1 8 14.7v-1.4a6.2 6.2 0 0 0-6.2 6.2zm7.8-4.8h4.5v-1.4H11zm9.3 4.8V21h1.4v-1.5zm-4.8-4.8a4.8 4.8 0 0 1 4.8 4.8h1.4a6.2 6.2 0 0 0-6.2-6.2zM6.2 21v-3H4.8v3zm7.5 0v-3h-1.4v3zm-4.2-9.7A3.3 3.3 0 0 1 6.2 8H4.8a4.7 4.7 0 0 0 4.7 4.7zM6.2 8a3.3 3.3 0 0 1 3.3-3.3V3.3A4.7 4.7 0 0 0 4.8 8zm3.3-3.3A3.3 3.3 0 0 1 12.8 8h1.4a4.7 4.7 0 0 0-4.7-4.7zM12.8 8a3.3 3.3 0 0 1-1.45 2.733l.786 1.159A4.7 4.7 0 0 0 14.2 8zm-1.45 2.733a3.3 3.3 0 0 1-1.85.567v1.4c.976 0 1.884-.298 2.636-.808zM14 4.7A3.3 3.3 0 0 1 17.3 8h1.4A4.7 4.7 0 0 0 14 3.3zM17.3 8a3.3 3.3 0 0 1-1.45 2.733l.786 1.159A4.7 4.7 0 0 0 18.7 8zm-1.45 2.733A3.3 3.3 0 0 1 14 11.3v1.4c.976 0 1.884-.298 2.636-.808zm-3.912-5.31A3.28 3.28 0 0 1 14 4.7V3.3c-1.11 0-2.133.386-2.938 1.031zM14 11.3a3.3 3.3 0 0 1-1.85-.567l-.786 1.159c.752.51 1.66.808 2.636.808z"
    ></path>
  </svg>
    )
}
/*Calendar*/
const SimpleCalendar = ({width,height,fill}:IconProps) => {
    return(
        <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#000"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 10h18M7 3v2m10-2v2M6.2 21h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 5 18.92 5 17.8 5H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 6.52 3 7.08 3 8.2v9.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21"
    ></path>
  </svg>
    )
}
/*OpenPages*/
const OpenPages = ({width,height,fill}:IconProps) =>{
    return(
        <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#000"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 10.4V20m0-9.6c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C8.96 4 7.84 4 5.6 4h-1c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 4.76 3 5.04 3 5.6v10.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 18 4.04 18 4.6 18h2.947c.54 0 .81 0 1.071.047q.349.061.674.204c.243.106.468.255.917.555L12 20m0-9.6c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C15.04 4 16.16 4 18.4 4h1c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C21 4.76 21 5.04 21 5.6v10.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C20.24 18 19.96 18 19.4 18h-2.947c-.54 0-.81 0-1.071.047q-.349.061-.674.204c-.243.106-.468.255-.917.555L12 20"
    ></path>
  </svg>
    )
}

const Clock = ({width,height,fill}:IconProps) => {
  return( <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <g id="SVGRepo_iconCarrier">
      <g
        id="Page-1"
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <g id="Icon-Set" fill={fill ?? "#000"} transform="translate(-412 -359)">
          <path
            id="clock"
            d="M438 376h2v-2h-2zm-10 13c-7.732 0-14-6.268-14-14 0-7.731 6.268-14 14-14s14 6.269 14 14c0 7.732-6.268 14-14 14m0-30c-8.837 0-16 7.164-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16m6.076 8.273 1.384 1.387 1.384-1.387-1.384-1.386zm-.293 14.505 1.414 1.414 1.414-1.414-1.414-1.414zM428 363a1 1 0 0 0-1 1v10.023h-8a1 1 0 0 0 0 2h9c.553 0 1-.447 1-.999V364a1 1 0 0 0-1-1m-6.308 4.323-1.414-1.414-1.414 1.414 1.414 1.414zm-2.959 14.509 1.384 1.387 1.384-1.387-1.384-1.387zM427 387h2v-2h-2z"
          ></path>
        </g>
      </g>
    </g>
  </svg>)
}

const CheckCircle = ({width,height,fill}:IconProps) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={width ?? 30} height={height ?? 30} viewBox="0 0 24 24">
    <g id="SVGRepo_iconCarrier" fill={fill ?? "#000"}>
      <path d="M10.5 15.25A.74.74 0 0 1 10 15l-3-3a.75.75 0 0 1 1-1l2.47 2.47L19 5a.75.75 0 0 1 1 1l-9 9a.74.74 0 0 1-.5.25"></path>
      <path d="M12 21a9 9 0 0 1-7.87-4.66 8.7 8.7 0 0 1-1.07-3.41 9 9 0 0 1 4.6-8.81 8.7 8.7 0 0 1 3.41-1.07 8.9 8.9 0 0 1 3.55.34.75.75 0 1 1-.43 1.43 7.6 7.6 0 0 0-3-.28 7.5 7.5 0 0 0-5.04 2.73 7.42 7.42 0 0 0-1.64 5.51 7.499 7.499 0 0 0 2.73 5.04 7.42 7.42 0 0 0 5.51 1.64 7.5 7.5 0 0 0 5.04-2.73 7.42 7.42 0 0 0 1.64-5.51.788.788 0 1 1 1.57-.15 9 9 0 0 1-4.61 8.81A8.7 8.7 0 0 1 12.93 21z"></path>
    </g>
  </svg>
  )
}

const Mail = ({width,height,fill}:IconProps) => {
  return(
      <svg xmlns="http://www.w3.org/2000/svg" width={width ?? 30} height={height ?? 30} fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#000"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M10 19H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 17.48 3 16.92 3 15.8V8.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 5 5.08 5 6.2 5h11.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 6.52 21 7.08 21 8.2V10m-.393-1.738-5.057 3.371c-1.283.856-1.925 1.284-2.618 1.45a4 4 0 0 1-1.864 0c-.694-.167-1.335-.594-2.618-1.45L3.147 8.1M14 21l2.025-.405c.177-.035.265-.053.347-.085a1 1 0 0 0 .207-.111c.073-.05.136-.114.264-.242L21 16a1.414 1.414 0 1 0-2-2l-4.157 4.157a2 2 0 0 0-.242.264 1 1 0 0 0-.11.207c-.033.082-.05.17-.086.347z"
    ></path>
  </svg>
  )
}
const EditPencil = ({width,height,fill}:IconProps) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width={width ?? 30} height={height ?? 30} fill="none" viewBox="0 0 24 24">
    <g id="SVGRepo_iconCarrier">
      <g id="Edit / Edit_Pencil_Line_01">
        <path
          id="Vector"
          stroke={fill ?? "#000"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M4 20h16M4 20v-4l8-8M4 20h4l8-8m-4-4 2.869-2.869.001-.001c.395-.395.593-.593.821-.667a1 1 0 0 1 .618 0c.228.074.425.272.82.666l1.74 1.74c.396.396.594.594.668.822a1 1 0 0 1 0 .618c-.074.228-.272.426-.668.822h0L16 12.001m-4-4 4 4"
        ></path>
      </g>
    </g>
  </svg>
  )
}
const Trashcan = ({width,height,fill}:IconProps) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width={width ?? 30} height={height ?? 30} fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ??"#000"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 6h16m-4 0-.27-.812c-.263-.787-.394-1.18-.637-1.471a2 2 0 0 0-.803-.578C13.939 3 13.524 3 12.695 3h-1.388c-.829 0-1.244 0-1.596.139a2 2 0 0 0-.803.578c-.243.29-.374.684-.636 1.471L8 6m10 0v10.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C15.72 21 14.88 21 13.2 21h-2.4c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C6 18.72 6 17.88 6 16.2V6m8 4v7m-4-7v7"
    ></path>
  </svg>
  )
}
const PlusSign = ({width,height,fill}:IconProps) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width={width ?? 30} height={height ?? 30} fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#000"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 12h16m-8-8v16"
    ></path>
  </svg>
  )
}
const CrossClose = ({width,height,fill}:IconProps) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width={width ?? 30} height={height ?? 30} fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      fill={fill ?? "#0F0F0F"}
      d="M20.746 3.329a1 1 0 0 0-1.415 0l-7.294 7.294-7.294-7.294a1 1 0 1 0-1.414 1.414l7.294 7.294-7.294 7.294a1 1 0 0 0 1.414 1.415l7.294-7.295 7.294 7.295a1 1 0 0 0 1.415-1.415l-7.295-7.294 7.295-7.294a1 1 0 0 0 0-1.414"
    ></path>
  </svg>
  )
}
const AttachClip = ({width,height,fill}:IconProps) => {
  return(
     <svg xmlns="http://www.w3.org/2000/svg" width={width ?? 30} height={height ?? 30} fill="none" viewBox="0 0 24 24">
    <g id="SVGRepo_iconCarrier">
      <g id="style=linear">
        <g id="attach">
          <path
            id="vector"
            stroke={fill ?? "#000"}
            strokeLinecap="round"
            strokeWidth="1.5"
            d="m20.648 10.616-8.762 8.762a5 5 0 0 1-7.072-7.071l8.132-8.132a3.5 3.5 0 1 1 4.95 4.95l-7.794 7.793a2 2 0 1 1-2.828-2.828l7.194-7.194"
          ></path>
        </g>
      </g>
    </g>
  </svg>
  )
}
const Pending =({width,height,fill}:IconProps) => {
  return(
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? 30} height={height ?? 30}
    viewBox="0 0 1024 1024"
  >
    <g id="SVGRepo_iconCarrier" fill={fill ?? "#0F1F3C"}>
      <path d="M182.99 146.2h585.14v402.29h73.14V73.06H109.84v877.71H512v-73.14H182.99z"></path>
      <path d="M256.13 219.34h438.86v73.14H256.13zm0 146.29h365.71v73.14H256.13zm0 146.28h219.43v73.14H256.13zm475.42 73.15c-100.99 0-182.86 81.87-182.86 182.86s81.87 182.86 182.86 182.86 182.86-81.87 182.86-182.86-81.86-182.86-182.86-182.86m0 292.57c-60.5 0-109.71-49.22-109.71-109.71 0-60.5 49.22-109.71 109.71-109.71 60.5 0 109.71 49.22 109.71 109.71.01 60.49-49.21 109.71-109.71 109.71"></path>
      <path d="M758.99 692.08h-54.86v87.27l69.39 68.76 38.61-38.96-53.14-52.66z"></path>
    </g>
  </svg>
  )
}
const Search = ({width,height,fill}:IconProps) => {
  return(
    <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#0F1F3C"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M11 6a5 5 0 0 1 5 5m.659 5.655L21 21m-2-10a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
    ></path>
  </svg>
  )
}
const MailSend = ({width,height,fill}:IconProps) => {
  return(
    <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-0.5 0 25 25">
    <g
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#0F1F3C"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path d="M9.01 21.39h10a4 4 0 0 0 4-4v-10a4 4 0 0 0-4-4h-12a4 4 0 0 0-4 4v5M1.01 18.39h10M1.01 15.39h4"></path>
      <path d="M22.209 5.42c-5.61 10.64-12.81 10.63-18.42 0"></path>
    </g>
  </svg>
  )
}
const Document = ({width,height,fill}:IconProps) => {
  return(
     <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#0F1F3C"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M8 13h6m-6 4h8M13 3H5v18h14V9m-6-6h1l5 5v1m-6-6v4c0 1 1 2 2 2h4"
    ></path>
  </svg>
  )
}
const Gift = ({width,height,fill}:IconProps) => {
  return(
     <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#0F1F3C"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 7v13m0-13H8.464c-.52 0-1.02-.21-1.389-.586A2.02 2.02 0 0 1 6.5 5c0-.53.207-1.04.575-1.414A1.95 1.95 0 0 1 8.465 3C11.214 3 12 7 12 7m0 0h3.536c.52 0 1.02-.21 1.389-.586.368-.375.575-.884.575-1.414s-.207-1.04-.575-1.414A1.95 1.95 0 0 0 15.535 3C12.786 3 12 7 12 7m-7 5h14v5.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C17.48 21 16.92 21 15.8 21H8.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C5 19.48 5 18.92 5 17.8zm-.4 0h14.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 11.24 21 10.96 21 10.4V8.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 7 19.96 7 19.4 7H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 7.76 3 8.04 3 8.6v1.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 12 4.04 12 4.6 12"
    ></path>
  </svg>
  )
}
const DownloadArrow = ({width,height,fill}:IconProps) => {
  return(
    <svg
    width={width ?? 30} height={height ?? 30}
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    stroke={fill ?? "#0F1F3C"}
    data-name="Layer 1"
    viewBox="0 0 512 512"
  >
    <path
      id="SVGRepo_iconCarrier"
      d="M256 409.7 152.05 305.75l21.45-21.45 67.33 67.32V34h30.34v317.62l67.33-67.32 21.5 21.45ZM445.92 351v93.22a3.61 3.61 0 0 1-3.47 3.48H69.15a3.3 3.3 0 0 1-3.07-3.48V351H35.74v93.22A33.66 33.66 0 0 0 69.15 478h373.3a33.85 33.85 0 0 0 33.81-33.82V351Z"
    ></path>
  </svg>
  )
}
const Clip = ({width,height,fill}:IconProps)=>{
  return(
    <svg
    width={width ?? 30} height={height ?? 30}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="_x32_"
    fill={fill ?? "#0F1F3C"}
    version="1.1"
    viewBox="0 0 512 512"
  >
    <path
      id="SVGRepo_iconCarrier"
      fill={fill ?? "#0F1F3C"}
      d="M454.821 253.582 273.256 435.14c-11.697 11.697-25.124 20.411-39.484 26.235-21.529 8.729-45.165 10.928-67.755 6.55-22.597-4.378-44.054-15.25-61.597-32.784-11.69-11.69-20.396-25.118-26.227-39.484-8.729-21.529-10.929-45.165-6.55-67.748 4.386-22.597 15.25-44.055 32.778-61.596l203.13-203.13c7.141-7.134 15.299-12.43 24.035-15.969 13.1-5.318 27.516-6.656 41.263-3.994 13.769 2.677 26.798 9.27 37.498 19.963 7.133 7.134 12.423 15.292 15.968 24.035 5.318 13.092 6.657 27.502 3.987 41.264s-9.262 26.783-19.955 37.498L213.261 363.064a25.4 25.4 0 0 1-8.436 5.61 25.75 25.75 0 0 1-14.495 1.396c-4.848-.954-9.355-3.225-13.15-7.006-2.534-2.534-4.364-5.368-5.603-8.429-1.865-4.571-2.342-9.668-1.402-14.495.947-4.841 3.225-9.355 7.005-13.149l175.521-175.528-29.616-29.617-175.528 175.52a67.4 67.4 0 0 0-14.801 22.313 67.55 67.55 0 0 0-3.702 38.202c2.449 12.73 8.686 24.989 18.503 34.799a67.2 67.2 0 0 0 22.305 14.809 67.53 67.53 0 0 0 38.21 3.702 67.17 67.17 0 0 0 34.806-18.511L439.97 195.602c11.142-11.149 19.571-24.113 25.167-37.917 8.394-20.717 10.48-43.314 6.294-64.971-4.179-21.643-14.73-42.432-31.46-59.155-11.149-11.142-24.114-19.571-37.918-25.166-20.717-8.401-43.314-10.48-64.971-6.301-21.643 4.186-42.431 14.737-59.155 31.468L74.803 236.695c-15.713 15.691-27.552 33.931-35.426 53.352-11.817 29.154-14.765 60.97-8.863 91.462 5.888 30.478 20.717 59.696 44.29 83.254 15.698 15.713 33.931 27.552 53.36 35.426 29.146 11.811 60.97 14.758 91.455 8.863 30.478-5.895 59.696-20.717 83.254-44.29l181.566-181.564z"
    ></path>
  </svg>
  )
}
const DeleteCross = ({width,height,fill,onClick}:DelteCrossProps) => {
  return(
     <svg style={{cursor:'pointer'}} onClick={onClick} width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 -0.5 25 25">
    <path
      id="SVGRepo_iconCarrier"
      fill={fill ?? "#0F1F3C"}
      d="M6.97 16.47a.75.75 0 1 0 1.06 1.06zm6.06-3.94a.75.75 0 1 0-1.06-1.06zm-1.06-1.06a.75.75 0 1 0 1.06 1.06zm6.06-3.94a.75.75 0 0 0-1.06-1.06zm-5 3.94a.75.75 0 1 0-1.06 1.06zm3.94 6.06a.75.75 0 1 0 1.06-1.06zm-5-5a.75.75 0 1 0 1.06-1.06zM8.03 6.47a.75.75 0 0 0-1.06 1.06zm0 11.06 5-5-1.06-1.06-5 5zm5-5 5-5-1.06-1.06-5 5zm-1.06 0 5 5 1.06-1.06-5-5zm1.06-1.06-5-5-1.06 1.06 5 5z"
    ></path>
  </svg>
  )
}
const Eye = ({width,height,fill}:IconProps) => {
  return(
    <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <g
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#0F1F3C"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0"></path>
      <path d="M12.001 5C7.524 5 3.733 7.943 2.46 12c1.274 4.057 5.065 7 9.542 7 4.478 0 8.268-2.943 9.542-7-1.274-4.057-5.064-7-9.542-7"></path>
    </g>
  </svg>
  )
}
const SendPaperPlane = ({width,height,fill}:IconProps) =>{
  return(
      <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      fill={fill ?? "#0F1F3C"}
      d="M20.33 3.67a1.45 1.45 0 0 0-1.47-.35L4.23 8.2A1.44 1.44 0 0 0 4 10.85l6.07 3 3 6.09a1.44 1.44 0 0 0 1.29.79h.1a1.43 1.43 0 0 0 1.26-1l4.95-14.59a1.41 1.41 0 0 0-.34-1.47M4.85 9.58l12.77-4.26-7.09 7.09zm9.58 9.57-2.84-5.68 7.09-7.09z"
    ></path>
  </svg>
  )
}
const OpenBook = ({width,height,fill}:IconProps) => {
  return(
      <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    width={width ?? 30} height={height ?? 30}
    fill={fill ?? "#0F1F3C"}
    version="1.1"
    viewBox="0 0 492.308 492.308"
  >
    <g id="SVGRepo_iconCarrier">
      <path d="M483.856 24.029c-77.822-11.136-159.897 1.983-237.701 37.818-77.8-35.841-159.871-48.959-237.703-37.818L0 25.236v408.111l11.24-1.611c75.327-10.788 155.072 2.356 230.077 37.716l1.507.808 2.825 1.73.213-.1.456.245 3.613-2.163.55-.26c75.51-35.62 155.245-48.731 230.587-37.976l11.24 1.611V25.236zM236.308 445.596c-56.755-24.63-115.582-37.212-173.192-37.212-14.567 0-29.063.803-43.423 2.423V42.414c71.005-8.442 145.572 4.115 216.615 36.519zm236.307-34.788c-71.101-8.038-145.409 3.918-216.615 34.798V78.933c71.043-32.399 145.63-44.952 216.615-36.519z"></path>
      <path d="m280.971 369.846 8.404 17.808c50.029-23.615 102.813-32.322 152.673-25.197l2.789-19.49c-53.674-7.693-110.342 1.61-163.866 26.879M280.971 290.904l8.404 17.808c50.029-23.611 102.813-32.322 152.673-25.192l2.789-19.49c-53.688-7.679-110.342 1.61-163.866 26.874M280.971 211.967l8.404 17.808c50.029-23.615 102.813-32.322 152.673-25.197l2.789-19.49c-53.674-7.684-110.342 1.609-163.866 26.879M280.971 133.029l8.404 17.808c50.029-23.615 102.813-32.327 152.673-25.197l2.789-19.49c-53.674-7.693-110.342 1.61-163.866 26.879M47.471 342.967l2.788 19.49c49.87-7.111 102.649 1.577 152.673 25.197l8.404-17.808c-53.509-25.264-110.163-34.552-163.865-26.879M47.471 264.029l2.788 19.49c49.87-7.125 102.644 1.582 152.673 25.192l8.404-17.808c-53.519-25.263-110.192-34.552-163.865-26.874M47.471 185.087l2.788 19.49c49.87-7.111 102.649 1.577 152.673 25.197l8.404-17.808c-53.509-25.264-110.163-34.562-163.865-26.879M47.471 106.149l2.788 19.49c49.87-7.12 102.649 1.582 152.673 25.197l8.404-17.808c-53.509-25.263-110.163-34.561-163.865-26.879"></path>
    </g>
  </svg>
  )
}
const Video = ({width,height,fill}:IconProps) => {
  return(
     <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <g id="SVGRepo_iconCarrier">
      <path  d="M0 0h24v24H0z"></path>
      <path
        stroke={fill ?? "#0F1F3C"}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 18h10a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2"
      ></path>
      <circle
        cx="6.5"
        cy="9.5"
        r="0.5"
        stroke={fill ?? "#0F1F3C"}
        strokeLinejoin="round"
      ></circle>
      <path stroke={fill ?? "#0F1F3C"} strokeLinejoin="round" d="m17 10 4-3v10l-4-3"></path>
    </g>
  </svg>
  )
}
const Save = ({width,height,fill}:IconProps) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width={width ?? 30} height={height ?? 30} fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      fill={fill ?? "#0F1F3C"}
      fillRule="evenodd"
      d="M18.172 1a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 23 5.828V20a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3zM4 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h1v-6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v6h1a1 1 0 0 0 1-1V6.828a2 2 0 0 0-.586-1.414l-1.828-1.828A2 2 0 0 0 17.172 3H17v2a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3V3zm13 18v-6a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v6zM9 3h6v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z"
      clipRule="evenodd"
    />
  </svg>
  );
}
const Conference = ({width,height,fill}:IconProps) => {
  return(
     <svg
     width={width ?? 30} height={height ?? 30}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Capa_1"
    fill={fill ?? "#0F1F3C"}
    version="1.1"
    viewBox="0 0 445.371 445.371"
  >
    <g id="SVGRepo_iconCarrier">
      <path d="m83.199 388.629.136-.312c2.311-5.006 6.526-8.812 12.534-11.33l19.052-8.773 1.01-.85a58 58 0 0 1-2.121-2.578c-8.613-11.189-13.345-26.055-13.743-43.025l-2.639-1.205-9.821-8.293-15.781 15.702h-.011l-1.813-.001h-.011l-15.78-15.701-9.823 8.293-20.442 9.409c-3.025 1.245-5.997 3.128-7.51 6.401 0 0-22.22 52.902-10.167 52.902h76.663c.15-.354.242-.575.267-.639"></path>
      <path d="M34.043 264.328c.354 32.673 18.615 52.143 36.866 52.143 15.593 0 36.51-19.47 36.867-52.143.226-22.666-10.57-36.238-36.867-36.238-26.298-.001-37.096 13.572-36.866 36.238M197.729 376.986c6.184 2.588 10.563 6.609 12.675 11.664.023.051.11.266.261.617h24.042c.15-.354.243-.574.269-.639l.141-.312c2.306-5.006 6.523-8.812 12.526-11.33l19.057-8.773 1.01-.85a56 56 0 0 1-2.124-2.578c-8.612-11.189-13.345-26.055-13.737-43.025l-2.638-1.205-9.821-8.293-15.787 15.702h-.006l-1.818-.001h-.006l-15.785-15.701-9.821 8.293-2.642 1.207c-.422 16.494-5.673 31.793-14.87 43.205a65 65 0 0 1-1.594 1.885l1.618 1.361z"></path>
      <path d="M222.685 316.471c15.592 0 36.514-19.471 36.866-52.144.229-22.666-10.57-36.238-36.866-36.238-26.297 0-37.092 13.572-36.864 36.238.351 32.673 18.614 52.144 36.864 52.144M428.936 336.365c-1.318-3.139-4.485-5.156-7.51-6.401l-20.443-9.409-9.822-8.293-15.779 15.702h-.013l-1.812-.001h-.012l-15.779-15.701-9.822 8.293-2.641 1.207c-.425 16.494-5.676 31.793-14.878 43.205a63 63 0 0 1-1.592 1.885l1.618 1.361 19.054 8.773c6.185 2.588 10.564 6.609 12.675 11.664.022.051.114.266.261.617h76.664c12.05.001-10.169-52.902-10.169-52.902"></path>
      <path d="M337.596 264.328c.354 32.673 18.616 52.143 36.866 52.143 15.593 0 36.512-19.47 36.865-52.143.229-22.666-10.569-36.238-36.865-36.238-26.299-.001-37.098 13.572-36.866 36.238M193.759 386.061l-20.44-9.416-9.823-8.275-15.78 15.691h-1.8359999999999999l-15.781-15.691-9.821 8.275-20.445 9.416c-3.024 1.236-5.997 3.117-7.508 6.406 0 0-22.221 52.904-10.168 52.904h129.282c12.052 0-10.167-52.904-10.167-52.904-1.319-3.155-4.485-5.17-7.513-6.406"></path>
      <path d="M146.795 284.193c-26.297 0-37.093 13.562-36.865 36.23.356 32.663 18.618 52.15 36.865 52.15 15.594 0 36.515-19.487 36.866-52.15.233-22.669-10.569-36.23-36.866-36.23M345.538 386.061l-20.445-9.416-9.82-8.275-15.782 15.691h-1.8339999999999999l-15.779-15.691-9.824 8.275-20.439 9.416c-3.026 1.236-5.996 3.117-7.514 6.406 0 0-22.218 52.904-10.166 52.904h129.282c12.053 0-10.169-52.904-10.169-52.904-1.319-3.155-4.487-5.17-7.51-6.406"></path>
      <path d="M298.575 372.576c15.592 0 36.51-19.488 36.866-52.15.226-22.671-10.568-36.23-36.866-36.23-26.297 0-37.099 13.561-36.864 36.23.35 32.661 18.61 52.15 36.864 52.15M209.917 140.722a3.78 3.78 0 0 0 3.971-.384l38.948-29.77a3.778 3.778 0 0 0 0-6.01L213.888 74.79a3.781 3.781 0 0 0-6.078 3.005v59.536a3.79 3.79 0 0 0 2.107 3.391"></path>
      <path d="M23.173 215.128h399.023a5.27 5.27 0 0 0 5.271-5.271V5.271A5.27 5.27 0 0 0 422.196 0H23.173a5.27 5.27 0 0 0-5.271 5.271v204.586a5.27 5.27 0 0 0 5.271 5.271M222.686 46.254c33.86 0 61.31 27.449 61.31 61.31s-27.449 61.309-61.31 61.309c-33.86 0-61.31-27.448-61.31-61.309-.001-33.861 27.45-61.31 61.31-61.31"></path>
    </g>
  </svg>
  )
}
const FileUpload = ({width,height,fill}:IconProps) => {
  return(
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={width ?? 30} height={height ?? 30}>
    <g
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#0F1F3C"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M18.5 20v-6m0 0 2.5 2.5M18.5 14 16 16.5M12 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h4.586a1 1 0 0 1 .707.293L12 7h7a2 2 0 0 1 2 2v2"></path>
    </g>
  </svg>
  );
}
export const AdminIcon = {
    Graph,
    UserGroup,
    SimpleCalendar,
    OpenPages,
    Clock,
    CheckCircle,
    Mail,
    EditPencil,
    Trashcan,
    PlusSign,
    CrossClose,
    AttachClip,
    Pending,
    Search,
    MailSend,
    Document,
    Gift,
    DownloadArrow,
    Clip,
    DeleteCross,
    Eye,
    SendPaperPlane,
    OpenBook,
    Video,
    Save,
    Gifts,
    Conference,
    FileUpload
}